import { useCallback } from 'react';
import { lessonsService } from '../services/lessonsService';
import { MagazineLesson } from '../types/trimestersSettings.types';

export const useLessons = () => {
  const buildLessons = useCallback((magazineId: string) => lessonsService.buildEmptySet(magazineId), []);
  const saveLessons = useCallback((lessons: MagazineLesson[]) => lessonsService.updateMany(lessons), []);

  return { buildLessons, saveLessons };
};
